import React from 'react';
import { Box } from '@mui/material';
import DataTable, { StatusColumn as StatusColumnType } from '../DataTable';

interface OpportunityData {
  id: string;
  client: string;
  title: string;
  date: string;
  status: string;
  value: string;
  source?: string;
  products?: string;
  unread_chats?: boolean;
}

interface OpportunitiesTableProps {
  data: OpportunityData[];
  className?: string;
  onRowClick?: (row: OpportunityData) => void;
}

const OpportunitiesTable: React.FC<OpportunitiesTableProps> = ({ data, className, onRowClick }) => {
  const columns: StatusColumnType[] = [
    {
      id: 'client',
      label: 'Cliente',
      minWidth: 150,
      format: (value: unknown, row?: any) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {row?.unread_chats && (
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: '#d32f2f',
                flexShrink: 0,
              }}
            />
          )}
          <span>{String(value || '')}</span>
        </Box>
      ),
    },
    // {
    //   id: 'title',
    //   label: 'Título',
    //   minWidth: 170,
    // },
    {
      id: 'date',
      label: 'Data',
      minWidth: 120,
    },
    {
      id: 'value',
      label: 'Valor',
      minWidth: 120,
      align: 'right',
    },
    {
      id: 'status',
      label: 'Status',
      minWidth: 120,
      renderStatus: true,
      statusVariants: {
        'Em negociação': {
          backgroundColor: '#e3f2fd',
          textColor: '#2196f3',
        },
        Aprovado: {
          backgroundColor: '#FAFFF6',
          textColor: '#356E01',
        },
        Rejeitado: {
          backgroundColor: '#ffebee',
          textColor: '#d32f2f',
        },
        'Em análise': {
          backgroundColor: '#fffdf0',
          textColor: '#682d03',
        },
      },
    },
    /* eslint-disable */
    ...(typeof data[0]?.products !== 'undefined'
      ? [
          {
            id: 'products',
            label: 'Produtos',
            minWidth: 170,
          },
        ]
      : []),
    /* eslint-enable */
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      statusField="status"
      containerClassName={className}
      fullWidth
      onRowClick={onRowClick}
    />
  );
};

export default OpportunitiesTable;
